export type DashboardSectionKey =
  | 'livePipeline'
  | 'testKpis'
  | 'testProgress'
  | 'testFunnel'
  | 'qualitaet'
  | 'devopsKpis'
  | 'devopsPipeline'
  | 'devopsBuilds'
  | 'activity';

export const DASH_SECTION_KEYS: readonly DashboardSectionKey[] = [
  'livePipeline',
  'testKpis',
  'testProgress',
  'testFunnel',
  'qualitaet',
  'devopsKpis',
  'devopsPipeline',
  'devopsBuilds',
  'activity',
] as const;

export const DASH_SECTION_LABELS: Readonly<Record<DashboardSectionKey, string>> = {
  livePipeline: 'liveDashboard.sections.livePipeline',
  testKpis: 'liveDashboard.sections.testKpis',
  testProgress: 'liveDashboard.sections.testProgress',
  testFunnel: 'liveDashboard.sections.testFunnel',
  qualitaet: 'liveDashboard.sections.qualitaet',
  devopsKpis: 'liveDashboard.sections.devopsKpis',
  devopsPipeline: 'liveDashboard.sections.devopsPipeline',
  devopsBuilds: 'liveDashboard.sections.devopsBuilds',
  activity: 'liveDashboard.sections.activity',
};

export const DASH_DEFAULT_SECTIONS: Readonly<Record<DashboardSectionKey, boolean>> = {
  livePipeline: true,
  testKpis: true,
  testProgress: true,
  testFunnel: true,
  qualitaet: false,
  devopsKpis: false,
  devopsPipeline: false,
  devopsBuilds: false,
  activity: false,
};

export interface DashboardConfig {
  sections: Record<DashboardSectionKey, boolean>;
  vonDatum: string | null;
  bisDatum: string | null;
  isDefault: boolean;
}
